module.exports = __webpack_public_path__ + "static/media/key.ab964510.svg";